import { render, staticRenderFns } from "./DayDeal.vue?vue&type=template&id=0c1365d3&"
import script from "./DayDeal.vue?vue&type=script&lang=js&"
export * from "./DayDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports